import { render, staticRenderFns } from "./ActividadesProgramadas.vue?vue&type=template&id=061da581&"
import script from "./ActividadesProgramadas.vue?vue&type=script&lang=js&"
export * from "./ActividadesProgramadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports